interface FunnelStepProps {
  label: string;
  count: number;
  totalForPercent: number;
  isLast?: boolean;
}

export function FunnelStep({
  label,
  count,
  totalForPercent,
  isLast,
}: FunnelStepProps) {
  const pct = totalForPercent > 0 ? (count / totalForPercent) * 100 : 0;
  const width = Math.max(Math.min(pct, 100), 0);
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-baseline justify-between">
        <span className="text-sm font-medium text-foreground">{label}</span>
        <span className="text-sm text-muted-foreground tabular-nums">
          {count.toLocaleString()}{' '}
          <span className="text-xs">({pct.toFixed(1)}%)</span>
        </span>
      </div>
      <div className="h-2 rounded-full bg-muted overflow-hidden">
        <div
          className="h-full bg-primary"
          style={{ width: `${width}%` }}
        />
      </div>
      {!isLast ? <div className="h-2" /> : null}
    </div>
  );
}
